"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceReadiness = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _ReadinessCheck = _interopRequireDefault(require("../ReadinessCheck"));
var _constants = require("../../../constants");
var DeviceReadiness = exports.DeviceReadiness = function DeviceReadiness(_ref) {
  var status = _ref.status,
    hideBottomBorder = _ref.hideBottomBorder,
    statusText = _ref.statusText,
    messageBody = _ref.messageBody,
    presenterId = _ref.presenterId;
  return /*#__PURE__*/_react["default"].createElement(_ReadinessCheck["default"], {
    title: "Device",
    status: status,
    statusText: statusText,
    onRetry: null,
    hideBottomBorder: hideBottomBorder,
    failedText: "You are on an unsupported device",
    presenterId: presenterId
  }, messageBody ? /*#__PURE__*/_react["default"].createElement("p", null, messageBody) : /*#__PURE__*/_react["default"].createElement("p", null, "Mobile devices are not supported. Please login on your desktop"));
};
DeviceReadiness.defaultProps = {
  status: _constants.CHECKING
};
DeviceReadiness.propTypes = {
  status: _propTypes.string.isRequired,
  messageBody: _propTypes.string,
  statusText: _propTypes.string,
  presenterId: _propTypes.string,
  hideBottomBorder: _propTypes.bool
};